import { DashboardListController as DashboardList } from './dashboardListController';

export default DashboardList;
